(function() {
    $noFilledError = "<span class='ajaxerror'><span class='error small'>"+$('#required_message').val()+"</span></span>";
    $badEmailError = "<span class='ajaxerror'><span class='error small'>"+$('#required_email').val()+"</span></span>";
    $noPrivacyError = "<span class='ajaxerror'><span class='error small'>"+$('#required_privacy').val()+"</span></span>";

    $('.required input, .required select, .required textarea, body#demo .required input, #form-demo-email').focusout(function(event) {
        if(!$(this).val()){
            $(this).closest('.error').removeClass('error');
            $(this).closest('.input-wrapper').find('.ajaxerror').remove();
            $error = $noFilledError;
            $(this).closest('.required, .input-wrapper').addClass('error');
            $(this).closest('.input-wrapper').append($error);
        }else{
            if($(this).attr('id') == "frm-email" || $(this).attr('id') == "form-demo-email") {
                if(!isValidEmailAddress($(this).val())) {
                    $error = $badEmailError;
                    $(this).closest('.required, .input-wrapper').addClass('error');
                    $(this).closest('.input-wrapper').append($error);
                }else{
                    $(this).closest('.error').removeClass('error');
                    $(this).closest('.input-wrapper').find('.ajaxerror').remove();
                }
            }else{
                $(this).closest('.error').removeClass('error');
                $(this).closest('.input-wrapper').find('.ajaxerror').remove();
            }
        }
    });

    function isValidEmailAddress(emailAddress) {
        var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return pattern.test(emailAddress);
    };

    $('.upgraded-submit').on('click',function(event){
        event.preventDefault();
        trySubmit();
    });

    function trySubmit(){
        $requiredfields = $('.upgraded-form').find('.required');
        $sizefields = $('.upgraded-form').find('.size');
        $counter = 0;
        $countedSize = 0;
        $numberToCount = 0;
        $('.ajaxerror').remove();
        $('.error').removeClass('error');

        if($requiredfields.length){
            $requiredfields.each(function(){
                if($(this).find('input, textarea').val() == ""){
                    $counter = $counter + 1;
                    $(this).find('.input-wrapper').addClass('error').append($noFilledError);
                }else if($(this).find('select').val() === ''){
                    $counter = $counter + 1;
                    $(this).find('.input-wrapper').addClass('error').append($noFilledError);
                }else if($(this).closest('fieldset').find('#frm-delivery-0').prop('checked') == false && $(this).closest('fieldset').find('#frm-delivery-1').prop('checked') == false){
                    $counter = $counter + 1;
                    $(this).find('.input-wrapper').addClass('error').append($noFilledError);
                }else if($(this).find('#frm-privacyagree').prop('checked') == false ){
                    $counter = $counter + 1;
                    $(this).find('.input-wrapper').andSelf().filter('.input-wrapper').addClass('error').append($noPrivacyError);
                }
            });
        }

        if($sizefields.length){
            $sizefields.each(function(){
                $numberToCount = parseFloat($(this).html().replace(',','.').replace(' ',''));
                if($(this).html().indexOf("KB") >= 0){
                    $countedSize = $countedSize + ($numberToCount / 1024);
                }else{
                    $countedSize = $countedSize + $numberToCount;
                }
            });
        }

        if($countedSize > 12){
            $('.fuerror').addClass('display');
            $counter = $counter + 1;
        }else{
            $('.fuerror').removeClass('display');
        }


        if($counter == 0){
            $('.download-form:not(.captcha-form)').submit();
            $('.upgraded-form:not(#fileupload):not(.captcha-form)').submit();
        }
    }


    $(document).on('click', '#fileupload .delete',function(event){
        var tempfilename = $(this).closest('.template-download').find('p.name a').html();
        $('#uploaded-files option[value="' + tempfilename + '"]').remove();
    });

})();
